import { ColorScheme } from '@design/design-tokens/themes/themes';
import clsx from 'clsx';
import React from 'react';

import styles from './Loading.module.scss';

interface LoadingProps {
  /** Extra class forwarded to the wrapper. */
  className?: string;
  /** Picks the brand logo asset (`logo-light.svg` vs `logo-dark.svg`). Defaults to `ColorScheme.Dark`. */
  colorScheme?: ColorScheme;
}

/**
 * Full-screen splash loader for app-level boot or route transitions.
 *
 * Renders the Reflexivity brand logo (light or dark per `colorScheme`)
 * with an indeterminate progress bar underneath. For component-level
 * loading use `SkeletonLoader`; for short inline waits use `Spinner`
 * or `ThreeDots`.
 */
export const Loading = ({
  className,
  colorScheme = ColorScheme.Dark,
}: LoadingProps) => (
  <div className={clsx(styles.loader, className)} data-testid="loading-view">
    <div className={styles.innerBox}>
      <div className={styles.logoBox}>
        <img
          data-testid="loading-logo"
          src={`/app/static/images/brand/logo-${colorScheme}.svg`}
          alt="logo"
        />
      </div>
      <div className={styles.progressBar}>
        <div className={styles.progressBarMeter} />
      </div>
    </div>
  </div>
);
